import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import LdsImage from "../../components/LdsImage";
import fifthCause from "../../assets/module-1/5th_leading_cause.svg";
import BarChart from "../../assets/module-1/horizontalbarchart.svg";
import VertBarChart from "../../assets/module-1/barchat.svg";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5 learning-heading">
            <h1 className="blue text-uppercase b mt-5">
              1.0.1 Epidemiology of AD
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 2 minutes</p>
          </section>
          <section>
            <div className="content-block mb-5 border">
              <h5 className="h5 b mt-3 ms-3">
                Fifth leading cause of death in patients ≥65 years of age
              </h5>
              <LdsImage
                src={fifthCause}
                style={{ maxWidth: "700px" }}
                alt="Blue Map of United States with text ‘5th Leading Cause of Death in Patients ≥ 65 Years of Age"
                className="mt-4 mb-4 ms-3 justify-content-center"
              />
            </div>
            <div className="content-block mb-5 border">
              <h5 className="h5 b mt-3 ms-3">
                Estimated Americans age 65 and older living with Alzheimer’s Dementia
              </h5>
              <LdsImage
                src={BarChart}
                style={{ maxWidth: "700px" }}
                alt="Bar graph showing estimated Americans aged 65 and older living with Alzheimer's Dementia. In 2024, 6.9 million; in 2060, 13.8 million."
                className="mt-4 mb-4 ms-3 justify-content-center"
              />
            </div>
            <div className="content-block mb-5 border">
              <h5 className="h5 b mt-3 ms-3">
                Total annual payments for people with AD and other dementias are
                projected to increase
              </h5>
              <LdsImage
                src={VertBarChart}
                style={{ maxWidth: "700px" }}
                alt="Bar graph showing projected total annual payments for people with Alzheimer's and other dementias. 345 billion currently, rising to 1 trillion"
                className="mt-4 mb-4 ms-3 justify-content-center"
              />
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/isi", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-0-2", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_1_0_1;
